<template>
    <div class="student-task-list-page">
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">PENILAIAN SISWA</h6>
                </div>
                <div class="col-lg-6 text-lg-right">
                </div>
            </div>
            <div class="text-center text-muted">
                <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <b-row>
                            <b-col lg="2" class="my-1">
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="6" class="my-1">
                            </b-col>
                            <b-col lg="4" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Cari"
                                    ></b-form-input>

                                    <b-input-group-append>
                                    <b-button style="border-radius:0px !important;" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table
                            :items="studentAppraisalList"
                            :fields="fields"
                            :busy="isBusy"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            responsive="sm"
                            show-empty
                            small
                            @filtered="onFiltered"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(image_path)="row">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" height="50px" :src="row.item.image_path">
                                    </a>
                                </div>
                            </template>
                            <template #cell(full_name)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.full_name}} ({{row.item.email}})</label>
                                    <div class="text-muted"><i class="fa fa-clock" aria-hidden="true"></i> {{row.item.created}}</div>
                                    <div class="d-flex">
                                        <div class="mr-1"><b-badge variant="warning">{{row.item.remark}}</b-badge></div>
                                        <div class="ml-1"><i class="fa fa-calendar" aria-hidden="true"></i> Nilai: <b-badge v-if="row.item.scores == 'Belum dinilai'" variant="warning">{{row.item.scores}}</b-badge> <label v-else>{{row.item.scores}}</label></div>
                                    </div>
                                </div>
                            </template>

                            <template #cell(actions)="row">
                                <div class="my-2">
                                    <a v-if="row.item.is_has_collected_task==1&&row.item.is_admin==1" href="javascript:void(0)" v-b-tooltip.hover title="Reset" class="icon-clicked p-1" @click="confirmReset(row.item.id)"><i class="fa fa-cogs" aria-hidden="true"></i></a>
                                </div>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-lg-end justify-content-center py-2">
                            <b-pagination
                                v-model="currentPage"
                                :totaws="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            // SquareLoader
        },
        data() {
            return {
                isBusy: false,
                showLoader: false,
                taId: this.$route.params.taId,
                items: [
                    { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
                    { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
                    {
                        isActive: false,
                        age: 9,
                        name: { first: 'Mini', last: 'Navarro' },
                        _rowVariant: 'success'
                    },
                    { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
                    { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
                    { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
                    {
                        isActive: true,
                        age: 87,
                        name: { first: 'Larsen', last: 'Shaw' },
                        _cellVariants: { age: 'danger', isActive: 'warning' }
                    },
                    { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
                    { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
                    { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
                ],
                fields: [
                    { key: 'image_path', label: 'Foto', sortable: false, class: 'foto-field'},
                    { key: 'full_name', label: 'Hasil Penilaian', sortable: true, sortDirection: 'desc', class: 'text-center' },
                    { key: 'actions', label: 'Aksi', class: 'action-field' }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                appraisal_form: {
                    id: null,
                    score: null,
                    note: null
                },
                nilai: null
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                studentAppraisalList: 'getStudentAppraisalList'
            })
        },
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async getStudentAppraisalList() {
                this.isBusy = true
                let appraisalId = this.$route.params.appraisalId
                let taId = this.$route.params.taId
				await this.$store.dispatch('getStudentAppraisalList', { appraisalId,taId })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            confirmReset(id) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.resetAppraisal(id)
                    }
                })
            },
            async resetAppraisal(id) {
				await this.$store.dispatch('resetAppraisal', { id })
					.then((res) => {
                        this.getStudentAppraisalList()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            }
        },
        mounted() {
            this.totalRows = this.studentAppraisalList.length
        },
        async created() {
            await this.getStudentAppraisalList()
        }
    }
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
</style>